import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'homepage-table',
  templateUrl: 'homepage-table.html',
  inputs: ['data']
})
export class HomepageTableComponent implements AfterViewInit {

  data: any;

  constructor() {
  }

  ngAfterViewInit(): void {
    
  }

}



// WEBPACK FOOTER //
// ./src/components/homepage-table/homepage-table.ts